import { render, staticRenderFns } from "./templateProductSize.vue?vue&type=template&id=876a7a40&scoped=true"
import script from "./templateProductSize.vue?vue&type=script&lang=js"
export * from "./templateProductSize.vue?vue&type=script&lang=js"
import style0 from "./templateProductSize.vue?vue&type=style&index=0&id=876a7a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876a7a40",
  null
  
)

export default component.exports